// removed by extract-text-webpack-plugin
module.exports = {"dash-card":"-main-dash-card-2PLntg-","dash-data-text1":"-main-dash-data-text1-Zs2qFS-","dash-data-text2":"-main-dash-data-text2-2llxS9-"};


//////////////////
// WEBPACK FOOTER
// ./src/views/dashboard/main.css
// module id = 1001
// module chunks = 0